var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractSignedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.944,
    height: 30.934,
    viewBox: "0 0 30.944 30.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#666;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.281,97.147a1.523,1.523,0,0,0-2.79-.365l-.254.441a.507.507,0,0,0-.69.183l-1.288,2.2-.441-.254a.507.507,0,1,0-.507.878l.441.254-4.312,7.472-1.065,2.846-.507.948a1.522,1.522,0,0,0,.081,1.644l-1.141,1.4-.32-.8a1.015,1.015,0,0,0-1.811-.142l-.183.309-.172-2.029a1.014,1.014,0,0,0-1.973-.238L192.1,115.63a.507.507,0,0,0,.319.639.439.439,0,0,0,.157.04.507.507,0,0,0,.482-.345l1.243-3.743.178,2.059a1.015,1.015,0,0,0,1.882.436l.188-.31.315.8a1.014,1.014,0,0,0,1.735.259l1.182-1.5a1.562,1.562,0,0,0,.4.051,1.522,1.522,0,0,0,1.324-.751l.507-.847,1.933-2.348,4.357-7.563.441.254a.509.509,0,0,1,.188.695l-2.029,3.515a.5.5,0,1,0,.857.528l2.029-3.515a1.521,1.521,0,0,0-.558-2.08l-.441-.254,1.268-2.2a.507.507,0,0,0-.183-.69l.254-.441a1.521,1.521,0,0,0,.152-1.177Zm-1.912.142a.507.507,0,0,1,.31-.238.533.533,0,0,1,.385.051.508.508,0,0,1,.239.309.533.533,0,0,1-.051.385l-.254.441-.883-.507Zm-6.914,14.162-.254-.147-.751-.436.72-1.927,1.6.923Zm-1.522,1.466a.507.507,0,0,1-.152-.665l.254-.441.882.507-.254.436a.507.507,0,0,1-.73.162Zm3.414-3.885-1.755-1.014,4.058-7.031L207.405,102Zm4.565-7.908-1.755-1.014,1.014-1.755,1.755,1.014Zm0,0",
    transform: "translate(-179.898 -89.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.507,112.039a.507.507,0,1,0,0,1.014h10.145a.507.507,0,0,0,0-1.014Zm0,0",
    transform: "translate(-89.913 -104.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M139.666,168.039H128.507a.507.507,0,0,0,0,1.014h11.159a.507.507,0,0,0,0-1.014Zm0,0",
    transform: "translate(-119.884 -157.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.159,216.546a.507.507,0,0,0-.507-.507H56.507a.507.507,0,1,0,0,1.014H66.652A.507.507,0,0,0,67.159,216.546Zm0,0",
    transform: "translate(-52.449 -202.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M252.058,216.039h-3.551a.507.507,0,1,0,0,1.014h3.551a.507.507,0,1,0,0-1.014Zm0,0",
    transform: "translate(-232.276 -202.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.58,257.053a.507.507,0,1,0,0-1.014H56.507a.507.507,0,1,0,0,1.014Zm0,0",
    transform: "translate(-52.449 -239.768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M168.507,257.053h3.551a.507.507,0,1,0,0-1.014h-3.551a.507.507,0,1,0,0,1.014Zm0,0",
    transform: "translate(-157.348 -239.768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.826,23.372a.507.507,0,0,0-.507.507v5.072a.507.507,0,0,1-.507.507H1.522a.507.507,0,0,1-.507-.507V1.561a.507.507,0,0,1,.507-.507h20.29a.507.507,0,0,1,.507.507v9.526a.507.507,0,0,0,1.014,0V1.561A1.522,1.522,0,0,0,21.811.039H1.522A1.522,1.522,0,0,0,0,1.561V28.952a1.522,1.522,0,0,0,1.522,1.522h20.29a1.522,1.522,0,0,0,1.522-1.522V23.879A.507.507,0,0,0,22.826,23.372Zm0,0",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractSignedIcon);
export default __webpack_public_path__ + "static/media/contract-signed-icon.d2abbb878d0b54ff56e2f87b2b88d126.svg";
export { ForwardRef as ReactComponent };